// removed by extract-text-webpack-plugin
module.exports = {"listItem":"_3ebYg","list":"IvzfP","stats":"Lz91n"};